import React,{useEffect} from 'react';
import NotesIcon from '@mui/icons-material/Notes';
import { Container, RightContainer, Title} from './styled';
import {  useSelector } from 'react-redux';


const ResultAvaliacaoFinal = () => {  
  const thisCard = useSelector((state) => state.card);
  const { complexidade, relevancia, avaliacaoFinal } = thisCard;  
  const { n1, n2, n3, observacao } = avaliacaoFinal;

  // Cálculo da criticidade e peso
  const criticidade = complexidade * relevancia;
  const getPeso = (criticidade) => {
    if (criticidade <= 6) return 1.0;
    if (criticidade <= 10) return 1.5;
    return 2.0;
  };

  const peso = getPeso(criticidade);

  // Cálculo da nota parcial (np)
  const notaParcial = (peso * (parseFloat(n1) + parseFloat(n2) + parseFloat(n3)))/3;

  const getDesempenhoEDesconto = (notaParcial) => {
    if ( notaParcial >= 97.5 && notaParcial <= 100) {
      return { desempenho: "Excelente", desconto: "0,00%" };
    }
    if (notaParcial >= 95 && notaParcial < 97.5) {
      return { desempenho: "Ótimo", desconto: "0,50%" };
    }
    if (notaParcial >= 92.5 && notaParcial < 95) {
      return { desempenho: "Muito Bom", desconto: "1,00%" };
    }
    if (notaParcial >= 90 && notaParcial < 92.5) {
      return { desempenho: "Bom", desconto: "1,50%" };
    }
    if (notaParcial >= 87.5 && notaParcial < 90) {
      return { desempenho: "Fraco", desconto: "2,00%" };
    }
    if (notaParcial >= 85 && notaParcial < 87.5) {
      return { desempenho: "Muito Fraco", desconto: "3,00%" };
    }
    if (notaParcial >= 82.5 && notaParcial < 85) {
      return { desempenho: "Ruim", desconto: "4,00%" };
    }
    if (notaParcial >= 80 && notaParcial < 82.5) {
      return { desempenho: "Muito Ruim", desconto: "5,00%" };
    }
    return { desempenho: "Desempenho Desconhecido", desconto: "-" };
  };
  
  // Dentro do componente:
  const desempenhoEDesconto = getDesempenhoEDesconto(notaParcial);
  
  useEffect(() => {
    if (avaliacaoFinal && (n1 || n2 || n3)) {      
    }
  }, [avaliacaoFinal, n1, n2, n3]);

return (
  <Container >    
    <NotesIcon fontSize='small' />
      <RightContainer>
        <Title>Avaliação Final</Title>
        <p>N1: {n1} | N2: {n2} | N3: {n3}</p>
        <p>Observação: {observacao}</p>
        <p>Peso: {peso.toFixed(1)}</p>
        <p>Nota Parcial: {notaParcial.toFixed(2)}</p>
        {/* <p>Desempenho: {desempenhoEDesconto.desempenho}</p>
        <p>Desconto: {desempenhoEDesconto.desconto}</p> */}
      </RightContainer>
  </Container>
  )
};

export default ResultAvaliacaoFinal;
